<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div [fxFlex]="labelFlex">
    {{ textLabel | translate }}*
  </div>

  <div [fxFlex]="formWrapperFlex">
    <form [formGroup]="formGroup"> 
      <mat-form-field class="width-100">
        <mat-chip-list #chipsWebUser aria-label="Web User" required>
          <mat-chip *ngFor="let data of multiSelect.selectedWebUsers"  [removable]="true" (removed)="toggleSelection(data, webUsers, 'selectedWebUsers', 'web_user')">
            {{data.username != 'all' ? (data.username + ' - ' + data.fullname) : data.fullname }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        
          <input 
            matInput 
            required
            #webUserInput 
            [matChipInputFor]="chipsWebUser" 
            formControlName="web_user" 
            [matChipInputAddOnBlur]="true"
            [matAutocomplete]="webUserAC" 
            (focus)="!loading.web_user && getInitialValues('web_user')" 
            (blur)="checkAutocompleteObject(formGroup, 'web_user', 'selectedWebUsers')"
            >
        
          <!-- <mat-icon *ngIf="webUserInput.value" matSuffix svgIcon="close-circle-outline" (click)="resetControl(formGroup.get('web_user')); webUserInput.value = ''"></mat-icon> -->
        
          <mat-icon 
            matSuffix 
            svgIcon="menu-down" 
            *ngIf="!webUserInput.value" 
            class="autocomplete-arrow-color cursor-pointer"
            (click)="webUserInput.focus()" 
            >
          </mat-icon>
        </mat-chip-list>
 
        <mat-autocomplete 
          id="id_group_dropdown"
          [displayWith]="displayFn"
          #webUserAC="matAutocomplete" 
          (opened)="autocompleteScroll('web_user','webUserAC','webUserACTr')"
          (closed)="autoCmpltClosed()"
          >
        <mat-option
          disabled
          *ngIf="!loading.web_user && webUsers?.length == 0"
          >
          {{ 'MSG_NO_DATA' | translate }}
        </mat-option>

        <ng-container>
          <mat-option [id]="'id_web_user_data_' + (i+1)" *ngFor="let data of webUsers; let i = index" [value]="data" [disabled]="data.disabled">
            <div (click)="optionClicked($event, data, webUsers, 'selectedWebUsers', 'web_user', webUserInput)" [class.disable]="data.disabled">
              <mat-checkbox [id]="'id_web_user_data_checkbox' + (i+1)" [checked]="data.selected" (change)="toggleSelection(data, webUsers, 'selectedWebUsers', 'web_user', webUserInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                {{data.username != 'all' ? (data.username + ' - ' + data.fullname) : data.fullname }}
              </mat-checkbox>
            </div>
          </mat-option>
        </ng-container>
      
        <mat-option *ngIf="loading.web_user" disabled>
          <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
        </mat-option>
      </mat-autocomplete>

        <mat-error *ngIf="formGroup.get('web_user').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('web_user').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_GROUP' | translate} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>